<!-- Builder Start -->
<div class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="!loading">
    <div [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      class="app-header-background one-logo-container global-max-width" [style.textAlign]="textAlign"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="">
        <!-- start: Logos-->
        <div [attr.data-aos]="imageAnimation ? imageAnimation : null" class="logo-container"
          [ngClass]="(!title && !subTitle)? 'logo-one-container':''">
          <ng-container>
            <div fxFlex>
              <img alt="logo" [src]="logoImg.image">
            </div>
          </ng-container>
        </div>

        <div [attr.data-aos]="textAnimation ? textAnimation : null" class="app-header-headline"
          [style.textAlign]="textAlign">
          <h1 [class]="'mb-5 '+titleSize"
            [ngStyle]="{ 'color': titleColor?titleColor:textColor,'font-weight':fontWeight }"
            [innerHtml]="title?title:'' | safeHtml"></h1>
          <!--start sub title-->
          <p [class]="'sub-title mb-20 '+textSize" [ngStyle]="{ 'color': textColor }" [innerHtml]="subTitle?subTitle:'' | safeHtml">
          </p>
          <!--end sub title-->
        </div>
        <!-- end: Logos -->
      </div>
    </div>
  </div>
</div>